/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import ArticleFeedbackForm from '../articleFeedbackForm/main.js';
import ErrorAlert from '../feedbackResponseAlerts/ErrorAlert.js';
import SuccessAlert from '../feedbackResponseAlerts/SuccessAlert.js';
import updateRatingRequest from './updateRatingRequest.js';


export default function({articleId, rating, sendEndpoint, updateEndpoint, namespace, storageKey}) {
  var data = new FormData()
  data.append(`${namespace}urlPath`, Liferay.currentURL)
  data.append(`${namespace}rating`, rating)
  data.append(`${namespace}dislikeReason`, 0)

  const rootElement = document.getElementById(`${namespace}articleFeedback`)
  const isArticleUseful = document.getElementById(`${namespace}is_article_useful`)

  return Liferay.Util.fetch(sendEndpoint, {
    headers: {
      'Accept': 'application/json'
    },
    method: 'POST',
    body: data
  }).then(function(response) {
    rootElement.removeChild(isArticleUseful)
    if (response.status == 201) {
      localStorage.setItem(storageKey, JSON.stringify({rating: rating, time: new Date().toISOString()}))

      if (rating == 1) {
        rootElement.append(SuccessAlert())
      } else {
        rootElement.append(ArticleFeedbackForm({
          updateRatingRequest: function({dislikeReason, comment}) {
            updateRatingRequest({
              dislikeReason,
              comment,
              endpoint: updateEndpoint,
              namespace
            })
          },
          namespace
        }))
      }
    } else if (response.status == 409) {
      rootElement.append(ErrorAlert(Liferay.Language.get('articlefeedback.error.alreadyReviewed')))
    } else {
      console.log(response.json())
      rootElement.append(ErrorAlert())
    }
  }).catch((error) => {
    console.log(error)
    rootElement.removeChild(isArticleUseful)
    rootElement.append(ErrorAlert())
  })
}
